export const selectStatus = (store) => store.session.status

export const selectUser = (store) => store.session.user

export const selectPage = (store) => store.session.page

export const selectTeam = (store) => store.session.team



// WEBPACK FOOTER //
// ./store/session/selectors/index.js